import { render, staticRenderFns } from "./Mainnav.vue?vue&type=template&id=3a28bd50&"
import script from "./Mainnav.vue?vue&type=script&lang=js&"
export * from "./Mainnav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports